export interface PasswordInterface {
  userId?: string;
  password: string;
  ForcePassword: boolean;
}

export class Password implements PasswordInterface {
  public userId?: string;
  public password: string;
  public ForcePassword:boolean;

  constructor({
    userId = undefined,
    password = undefined,
    ForcePassword = undefined,
  }: PasswordInterface) {
    this.userId = userId;
    this.password = password;
    this.ForcePassword = ForcePassword;
  }
}
